import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const { FiChevronRight, FiHome } = FiIcons;

function Breadcrumb({ items }) {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.path ? `https://example.com${item.path}` : undefined
    }))
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
      <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-6" aria-label="Breadcrumb">
        <ol className="flex items-center space-x-2">
          <li>
            <Link 
              to="/" 
              className="flex items-center hover:text-blue-600 transition-colors focus:ring-2 focus:ring-blue-500 rounded px-1"
              aria-label="Home"
            >
              <SafeIcon icon={FiHome} className="w-4 h-4" />
            </Link>
          </li>
          {items.map((item, index) => (
            <li key={index} className="flex items-center space-x-2">
              <SafeIcon icon={FiChevronRight} className="w-4 h-4 text-gray-400" aria-hidden="true" />
              {item.path && index < items.length - 1 ? (
                <Link 
                  to={item.path}
                  className="hover:text-blue-600 transition-colors focus:ring-2 focus:ring-blue-500 rounded px-1"
                >
                  {item.name}
                </Link>
              ) : (
                <span className="text-gray-900 font-medium" aria-current="page">
                  {item.name}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}

export default Breadcrumb;